import { useEffect } from 'react';

interface SEOOptions {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
}

const DEFAULT_TITLE = 'MD Label Maker - 미니디스크 라벨 제작 도구';
const DEFAULT_DESC =
  'MD Label Maker로 6종의 미니디스크 인쇄부를 실시간으로 디자인하고 고품질 PNG로 내보내세요.';

export function useSEO({ title, description, image, url }: SEOOptions = {}) {
  useEffect(() => {
    const finalTitle = title ? `${title} | MD Label Maker` : DEFAULT_TITLE;
    const finalDesc = description || DEFAULT_DESC;
    const finalUrl = url || window.location.href;

    const previousTitle = document.title;
    document.title = finalTitle;

    updateMeta('name', 'description', finalDesc);

    updateMeta('property', 'og:title', finalTitle);
    updateMeta('property', 'og:description', finalDesc);
    updateMeta('property', 'og:url', finalUrl);
    if (image) updateMeta('property', 'og:image', image);

    updateMeta('name', 'twitter:title', finalTitle);
    updateMeta('name', 'twitter:description', finalDesc);
    if (image) updateMeta('name', 'twitter:image', image);

    return () => {
      document.title = previousTitle;
    };
  }, [title, description, image, url]);
}

function updateMeta(attr: 'name' | 'property', key: string, value: string) {
  let meta = document.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute(attr, key);
    document.head.appendChild(meta);
  }
  meta.content = value;
}
